import React from "react";
import { XExecutableTester } from "../XExecutableTester";
import { getValueTableWithDeferentType } from "../../../Rule/Table/ValueTable/Testing/TestDataSetup";
import { StoryNode } from "../../StoryBook/StoryData";
import { getIfElseSimpleRule } from "../../../Expressions/Testing/LogicData";
import { getFilledDataDefinition } from "../../../rule-engine-core/Common/Data/DataTestData";
import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { IfThenExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/IfThenExpression";

export const ValueTableTester = [
    new StoryNode(
        () => {
            let ruleDefinition = getValueTableWithDeferentType();

            return <XExecutableTester executable={ruleDefinition} />;
        },
        "Shared",
        "Tester",
        "Value Table",
        "Default",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getValueTableWithDeferentType();

            return <XExecutableTester executable={ruleDefinition} />;
        },
        "Shared",
        "Tester",
        "Value Table",
        "Default",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getValueTableWithDeferentType();
            ruleDefinition.rows[1].cells[0].values = ["James Bond", "Jose Chachin", "Fred Williams"];

            return <XExecutableTester executable={ruleDefinition} />;
        },
        "Shared",
        "Tester",
        "Value Table",
        "Multiple Values",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getValueTableWithDeferentType();
            ruleDefinition.columns[1].columnName = "isMarried";

            ruleDefinition.columns[1].expression.expression = getIfElseSimpleRule().expression;
            let idatadef = getFilledDataDefinition();
            idatadef.fields.push(new BooleanDataDefinition("isEmployee"));

            (
                ruleDefinition.columns[1].expression.expression as IfThenExpression
            ).ifBranches[1].ifExpression.elements[0].variableName = "cellValue";

            ruleDefinition.inputData = () => idatadef;

            return <XExecutableTester executable={ruleDefinition} />;
        },
        "Shared",
        "Tester",
        "Value Table",
        "If Then",
    ),
];
